(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ns-hopfy-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  $('.ns-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1.2 }
      }
    ]
  });

  function setProgress(index) {
    var totalSlides = $('.ns-slider')[0].slick.slideCount;
    var percentage = ((index + 1) / totalSlides) * 100;
    document.querySelector('.ns-progress span').style.width = percentage + '%';
  }

  setProgress(0);

  $('.ns-slider').on('afterChange', function(event, slick, currentSlide){
    setProgress(currentSlide);
  });

});

  } catch(e) { console.error(e); }
})();
})();
